import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
import { lessonFeatures } from '../data/lessonContent';
export function LessonFeaturesSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-153" data-mp="3b302kmr56rbc">
      <div className="max-w-5xl mx-auto" data-id="element-154" data-mp="3b52whhvf14lc">
        <div className="text-center mb-14" data-id="element-155" data-mp="36bi9slz9vx1g">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-156" data-mp="36agpdqwd9y72">Dans chaque leçon, sans exception</p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-157" data-mp="3g2cydwzzr8q2">🗂️ Chaque composant inclut</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-158" data-mp="3u249npz4ib0d">
            Tu ouvres la leçon et tout est là — de l&apos;objectif d&apos;apprentissage jusqu&apos;au corrigé.
          </p>
        </div>
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-159" data-mp="1znuut4c5m2kv">
          {lessonFeatures.map((feature, index) => <motion.li key={feature} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index % 3 * 0.06
        }} className="flex items-center gap-3 bg-black border border-gold/20 rounded-xl px-4 py-3" data-id="element-160" data-mp="1uq1q6fqi1gmp" data-mpi={index}>
              <FileText size={18} className="text-gold shrink-0" data-id="element-161" data-mp="2z2lte9y7zjch" />
              <span className="text-sm text-gray-200" data-id="element-162" data-mp="2z3wug20a6czw">{feature}</span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}